import { Instance } from "@/context/auth/AuthContext";
import { isSupportedLocale, SupportedLocale } from "@/i18n";
import { Artwork } from "@/lib/types";
import { isValidDimField } from "./shared/dimensions";

export const PHOTOGRAPHY_TYPE_VALUES = [
  "Photographie",
  "Photograph",
  "Fotografía",
  "Fotografie",
] as const;


/**
 * Vérifie si le module photo est activé pour un artwork donné
 */
export function isPhotoModuleEnabled(
  artwork: Artwork,
  instanceData: Instance,
  locale: SupportedLocale,
): boolean {
  if (!instanceData?.isModulePhotoEnabled) {
    return false;
  }

  const artworkTypeInLocale = isSupportedLocale(locale)
    ? artwork.oeuvresDescriptionTypeOeuvreMultilingual?.[locale]
    : undefined;

  if (!artworkTypeInLocale) {
    return false;
  }

  return PHOTOGRAPHY_TYPE_VALUES.includes(
    artworkTypeInLocale as (typeof PHOTOGRAPHY_TYPE_VALUES)[number],
  );
}

/**
 * Vérifie si l'œuvre a des dimensions valides
 */
export function hasValidDimensions(artwork: Artwork): boolean {
  const dimensions = artwork.oeuvresDescriptionDimensionsOeuvre;

  // Si on a des dimensions brutes, on considère qu'elles sont valides
  if (artwork.oeuvresDescriptionDimensionsOeuvreRaw) {
    return true;
  }

  // Si pas de dimensions du tout, elles ne sont pas valides
  if (!dimensions) {
    return false;
  }

  // Vérifier si au moins une dimension est valide
  return (
    isValidDimField(dimensions.cm_width) ||
    isValidDimField(dimensions.cm_height) ||
    isValidDimField(dimensions.cm_depth) ||
    isValidDimField(dimensions.cm_diameter)
  );
}

